import { render } from "./NotificationFeed.vue?vue&type=template&id=5a63c0d9"
import script from "./NotificationFeed.vue?vue&type=script&lang=js"
export * from "./NotificationFeed.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/NotificationFeed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a63c0d9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a63c0d9', __exports__)) {
    api.reload('5a63c0d9', __exports__)
  }
  
  module.hot.accept("./NotificationFeed.vue?vue&type=template&id=5a63c0d9", () => {
    api.rerender('5a63c0d9', render)
  })

}


export default __exports__